module.exports = __webpack_public_path__ + "files/0a35093a5535ac91286ce0d93c57eced.png";